import { createFileRoute } from "@tanstack/react-router"

import { AccountRouteComponent } from "@/routes/_authenticated/account/route"
import { Crumb } from "@/utilities/types/local"

export const Route = createFileRoute("/qr/$qrLookupID/_authenticated/account")({
  component: AccountRouteComponent,
  loader: () => {
    return { crumb: { translationKey: "common:account.title" } as Crumb }
  },
})
